<template>
	<div id="top1">
		<div class="cc-header">学生考勤统计</div>
		<div class="title_tab float-l">
			<div class="legend-color"><span class="greenbg"></span>正常</div>
			<div class="legend-color"><span class="purplebg"></span>请假</div>
			<div class="legend-color"><span class="redbg"></span>异常</div>
		</div>
		<div class="date_switch float-r">
			<ul>
				<li class="date-type-stu on" v-on:click="changeType($event,'day')">日</li>
				<li class="date-type-stu" v-on:click="changeType($event,'week')">周</li>
				<li class="date-type-stu" v-on:click="changeType($event,'month')">月</li>
			</ul>
		</div>
		<div class="main-value" id="stu_att"></div>
	</div>
</template>

<script>
	//日期操作函数
	import {getNowDate,getWeek,getMonth} from "@/common/dateUtil.js";
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	const echarts = require("echarts");
	export default {
		data() {
			return {
				beginTime: getNowDate(),
				endTime: getNowDate()
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，30分钟
			let _this = this;
			setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 30);
		},
		methods: {
			initData() {
				let _this = this;
				// 基于准备好的dom，初始化echarts实例
				let myChartPieLeft = echarts.init(document.getElementById("stu_att"));
				this.$http.get("/dataView/headmaster/studentAttend?orgId=" + orgId + "&beginTime=" + _this.beginTime + "&endTime=" + _this.endTime).then(res => {
					if (res.data.code === 200) {
						var option = {
							tooltip: {
								trigger: 'item'
							},
							grid: {
								top: "10%",
								bottom: "25%",
							},
							series: [{
								name: '学生考勤',
								type: 'pie',
								radius: ['35%', '65%'],
								center: ['50%', '45%'],
								itemStyle: {
									normal: {
										borderRadius: 5,
										borderColor: '#181b37',
										borderWidth: 3,
										label: {
											alignTo: 'labelLine',
											formatter: '{b} : {c}',
											textStyle: {
												color: '#d3d6ff',
												fontWeight : 600 ,
												fontSize: fontSize(0.18)
											}
										}
									}
								},
								labelLine: {
									normal: {
										length: 15,
										length2: 50
									}
								},
								data: [
									{
										value: res.data.result.normalNum,
										name: '正常',
										itemStyle: {
											color: '#3ab795',
										}
									},
									{
										value: res.data.result.leaveNum,
										name: '请假',
										itemStyle: {
											color: '#751a8f',
										}
									},
									{
										value: res.data.result.abnormalNum,
										name: '异常',
										itemStyle: {
											color: '#ea4d44',
										}
									}
								]
							}]
						};
						myChartPieLeft.setOption(option);
						// 响应式变化
						window.addEventListener("resize", () => myChartPieLeft.resize(), false);
					}
				});
			},
			changeType: function(ele,type){
				let _this = this;
				var doms = document.getElementsByClassName("date-type-stu");
				for (let i = 0; i < doms.length; i++) {
					doms[i].classList.remove("on");
				}
				ele.currentTarget.classList.add("on");
				if(type == 'day'){
					_this.beginTime = getNowDate();
					_this.endTime = getNowDate();
				}else if(type == 'week'){
					_this.beginTime = getWeek('s',0);
					_this.endTime = getWeek('e',0);
				}else{
					_this.beginTime = getMonth('s',0);
					_this.endTime = getMonth('e',0);
				}
				_this.initData();
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};

	function fontSize(res) {
		let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (!clientWidth) return;
		let fontSize = 100 * (clientWidth / 1920);
		return res * fontSize;
	}
</script>

<style lang="scss">
	#top1 {
		width:100%;
		height: 100%;

		@media screen and (min-width: 768px) and (max-width: 992px) {}

		@media screen and (min-width: 1200px) and (max-width: 1920px) {}
	}
</style>
